import { createApi } from '@reduxjs/toolkit/query/react'
import { createBaseQueryWithReauth } from 'store/auth/base-query-with-reauth'
import {
  BorderConnectSendPayload,
  BorderConnectTrip,
  ManifestKind,
} from './borderconnect.types'

const baseUrl = `${process.env.REACT_APP_ONBOARDING_SERVICE_API}`

export const borderConnectApi = createApi({
  reducerPath: 'borderConnectApi',
  baseQuery: createBaseQueryWithReauth(baseUrl!),
  tagTypes: ['BorderConnectTrips'],
  endpoints: (builder) => ({
    listBorderConnectTrips: builder.query<
      BorderConnectTrip[],
      { userId: string; manifestType?: ManifestKind }
    >({
      query: ({ userId, manifestType }) => ({
        url: 'oapi/v1/borderconnect',
        params: {
          PK: userId,
          ...(manifestType ? { manifestType } : {}),
        },
      }),
      keepUnusedDataFor: 0,
      providesTags: (_result, _error, { userId, manifestType }) => [
        { type: 'BorderConnectTrips', id: `${userId}:${manifestType ?? 'ALL'}` },
      ],
    }),

    sendBorderConnectTrip: builder.mutation<
      BorderConnectTrip,
      BorderConnectSendPayload
    >({
      query: (body) => ({
        url: 'oapi/v1/borderconnect/send',
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, { PK }) => [
        { type: 'BorderConnectTrips', id: `${PK}:ACE` },
        { type: 'BorderConnectTrips', id: `${PK}:ACI` },
        { type: 'BorderConnectTrips', id: `${PK}:ALL` },
      ],
    }),
  }),
})

export const {
  useListBorderConnectTripsQuery,
  useSendBorderConnectTripMutation,
} = borderConnectApi
